import { subWeeks, subMonths, subYears, lightFormat } from "date-fns";

export type ITimespan = "Week" | "Month" | "3 Months" | "Year";
export type IInterval = "day" | "week" | "month";

const formatDate = (d: Date) => lightFormat(d, "yyyy-MM-dd");

export const TIMESPAN_OPTIONS = {
  "Week": formatDate(subWeeks(new Date(), 1)),
  "Month": formatDate(subMonths(new Date(), 1)),
  "3 Months": formatDate(subMonths(new Date(), 3)),
  "Year": formatDate(subYears(new Date(), 1)),
};

export const getTimespanInterval = (timespan: ITimespan) => {
  if (timespan === "Week") return "day";
  if (["Month", "3 Months"].includes(timespan)) return "week";
  if (timespan === "Year") return "month";
};
